import { Input } from 'antd';
import cx from 'classnames';
import React, { useRef } from 'react';
import InputMask from 'react-input-mask';
import styles from './ipv4AddressInput.module.scss';

type Props = {
	id?: string;
	key?: string;
	disabled?: boolean;
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	addressValidation: boolean;
	defaultValue?: string;
};

const checkIPv4 = value => {
	const subIps = value.split('.');

	if (subIps.length > 4) {
		return false;
	}

	const invalidSubips = subIps.filter(ip => {
		if (ip.length > 3) {
			return true;
		}
		ip = parseInt(ip);
		return ip < 0 || ip > 255;
	});

	if (invalidSubips.length !== 0) {
		return false;
	}

	let emptyIpCount = 0;

	subIps.forEach(ip => {
		if (ip === '') {
			emptyIpCount++;
		}
	});

	if (emptyIpCount > 1) {
		return false;
	}
	return true;
};

const formatChars = {
	'9': '[0-9.]',
};

const IPv4AddressInput: React.FC<Props> = ({ addressValidation, ...props }) => {
	const valueRef = useRef<string>('');
	const beforeMaskValueChange = (newState, oldState/* , _, input */) => {
		let value = newState.value;
		const oldValue = oldState.value;
		let selection = newState.selection;
		let cursorPosition = selection ? selection.start : null;
		const result = checkIPv4(value);

		if (!result) {
			value = value.trim();
			const newValue = value.substring(0, value.length - 1) + '.' + value.substring(value.length - 1);

			if (checkIPv4(newValue)) {
				cursorPosition++;
				selection = { start: cursorPosition, end: cursorPosition };
				value = newValue;
			} else {
				value = oldValue;
			}
		}

		valueRef.current = value;

		return {
			value,
			selection,
		};
	};

	return (
		<InputMask
			formatChars={formatChars}
			mask='999999999999999'
			maskChar={null}
			alwaysShowMask={false}
			beforeMaskedValueChange={beforeMaskValueChange}
			{...props}
			onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
				e.currentTarget.value = valueRef.current;
				e.target.value = valueRef.current;
				props?.onChange(e);
			}}>
			{inputProps => (
				<Input
					{...inputProps}
					id={props.id}
					key={props.key}
					disabled={props.disabled}
					defaultChecked={props.defaultValue}
					maxLength={15}
					className={cx(styles.input, {
						[styles.error]: addressValidation,
					})}
				/>
			)}
		</InputMask>
	);
};

export { IPv4AddressInput };
